<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col
                cols="4"
              >
                <v-text-field
                  v-model="search"
                  placeholder="Key in classroom name here"
                  append-icon="search"
                  label="Search classroom type"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
              <v-col
                cols="4"
              >
                <v-select
                  v-model="statusFilter"
                  :items="items"
                  item-text="state"
                  item-value="value"
                  label="Classroom Type's Status"
                  placeholder="Active / Deleted"
                />
              </v-col>
              <v-col
                cols="2"
                offset-md="2"
              >
                <setup-training-classroom-types-dialog-create
                  @created="loadClassroomTypes"
                />
              </v-col>
            </v-row>
          </v-card-actions>
          
          <v-data-table
            :headers="headers"
            :items="filteredClassroomTypes"
            :loading="tableLoading"
            :search="search"
          >
            <template v-slot:item.name="{ item }">
              <div>
                <span>
                  {{ item.name }}
                </span>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <span v-if="statusFilter">
                <setup-training-classroom-types-dialog-edit
                  :classroom-type="item"
                  @updated="loadData"
                />
                <span class="mx-1" />
                <setup-training-classroom-types-dialog-delete
                  :classroom-type="item"
                  @deleted="loadData"
                />
              </span>
              <span v-else>
                <setup-training-classroom-types-dialog-restore
                  :classroom-type="item"
                  @restored="loadData"
                />
              </span>
            </template>
          </v-data-table>
        </v-card> 
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupTrainingClassroomTypesDialogCreate: () => import('@/components/setup/training/classroom-types/DialogCreate'),
      SetupTrainingClassroomTypesDialogEdit: () => import('@/components/setup/training/classroom-types/DialogEdit'),
      SetupTrainingClassroomTypesDialogDelete: () => import('@/components/setup/training/classroom-types/DialogDelete'),
      SetupTrainingClassroomTypesDialogRestore: () => import('@/components/setup/training/classroom-types/DialogRestore'),
    },
    metaInfo () {
      return {
        title: 'Classroom Types',
      }
    },
    data () {
      return {
        classroomTypes: [],
        trashedClassroomTypes: [],
        headers: [
          {
            text: 'Classroom Types',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Actions',
            sortable: false,
            value: 'action',
          },
        ],

        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
      }
    },
    computed: {
      filteredClassroomTypes () {
        return this.statusFilter ? this.classroomTypes : this.trashedClassroomTypes
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.loadClassroomTypes()
        this.loadTrashedClassroomTypes()
      },
      loadClassroomTypes () {
        this.$api.classroomTypes().list()
          .then(response => {
            this.classroomTypes = response.data
            this.tableLoading = false
          })
      },
      loadTrashedClassroomTypes () {
        this.$api.classroomTypes().listTrashed()
          .then(response => {
            this.trashedClassroomTypes = response.data
          })
      },
    },
  }
</script>

<style lang='css' scoped>
</style>
